<template>
  <div class="invoice-details-view width-responsiveness">
    <div class="invoice-details-view__content">
      <div class="invoice-details-view__header">
        <img
          src="/static/images/icon-return-arrow.svg"
          alt="busca"
          class="icon-arrow"
          @click="handleBackButton()"
        >
        <div class="wrapper">
          <h1>Fatura de {{ mesAno.charAt(0).toUpperCase() + mesAno.slice(1) }} - Demandas mensais</h1>

          <div class="total">
            <p>
              Valor total: <span>{{ totalBilling }}</span>
            </p>
          </div>
        </div>
      </div>

      <div class="filter">
        <h2>FILTRAR POR:</h2>
        <div class="invoice-details-view__search">
          <InvoiceSearchFieldSelector
            :default-start-date="defaultStartDate"
            :default-end-date="defaultEndDate"
            :options="dateSelectOptions"
            :clean-date="cleanDate"
            :clear-button="true"
            :limit-range-date="true"
            @updateSearchValue="handleSearchValueUpdate"
          />

          <SearchFieldSelector
            :options="searchOptions"
            @updateSearchValue="handleSearchValueUpdate"
          />

          <button
            class="md-button btn btn-primary btn-search"
            @click="getResultsByFilter"
          >
            <md-icon
              md-src="/static/images/icon-search.svg"
              class="icon-search"
            >
              search
            </md-icon>
            Buscar
          </button>
        </div>
      </div>
      <Table
        :list="invoiceExams"
        :columns="examColumns"
        :is-loading-list="isLoadingList"
        :table-size="100"
        @clickRow="handleClickRow"
        @orderBy="orderByProp"
      />

      <Pagination
        v-if="totalPages > 1"
        :current-page="currentPage"
        :total-pages="totalPages"
        @page-change="handleChangePage"
      />
    </div>
  </div>
</template>
<script>
import Moment from 'moment'
import 'moment/locale/pt-br'

import Table from '@/components/common/Table'
import Pagination from '@/components/common/Pagination'
import SearchFieldSelector from '@/components/common/SearchFieldSelector'
import billings from '../../api/billings'
import { formatCurrency } from '../../utils/format-currency'
import notify from '@/api/notification'
import InvoiceSearchFieldSelector from './components/InvoiceSearchFieldSelector.vue'

export default {
  name: 'InvoiceDetails',
  components: {
    Table,
    Pagination,
    InvoiceSearchFieldSelector,
    SearchFieldSelector
  },
  data() {
    const todayStr = Moment().format('YYYY-MM-DD')
    const startDateStr = Moment().subtract(30, 'days').format('YYYY-MM-DD')

    return {
      cleanDate: 0,
      filter: {
        OS_ALVARO: null,
        PATIENT: null,
        byResultDate: false,
        EXAM: null
      },
      searchPeriod: {
        startDate: startDateStr,
        endDate: todayStr
      },
      dateSelectOptions: [
        {
          value: 'date',
          label: 'Data de Cadastro',
          placeholder: 'Data de Cadastro',
          limitDays: 1827,
          singleDate: false,
          selected: true,
          propName: 'CREATION_INTERVAL',
          type: 'date'
        },
        {
          value: 'dateRange',
          label: 'Data de Resultado',
          placeholder: 'Data de Resultado',
          limitDays: 1827,
          singleDate: false,
          selected: true,
          propName: 'RESULT_RANGE',
          type: 'date'
        }
      ],
      searchOptions: [
        {
          value: 'PATIENT',
          label: 'Nome do Paciente',
          placeholder: 'Pesquisar por...',
          limitDays: null,
          singleDate: false,
          selected: false,
          propName: 'PATIENT',
          type: 'PATIENT'
        },
        {
          value: 'OS_ALVARO',
          label: 'Os Alvaro',
          placeholder: 'Pesquisar por...',
          limitDays: null,
          singleDate: false,
          selected: false,
          propName: 'OS_ALVARO',
          type: 'OS_ALVARO'
        },
        {
          value: 'EXAM',
          label: 'Exame',
          placeholder: 'Pesquisar por...',
          limitDays: null,
          singleDate: false,
          selected: false,
          propName: 'EXAM',
          type: 'EXAM'
        }
      ],
      invoiceId: this.$route.params.id,
      invoiceExams: [],
      examColumns: [
        { name: 'OS', propName: 'numberOs', widthPercent: 15, textPosition: 'left' },
        { name: 'PACIENTE', propName: 'patient', widthPercent: 30, textPosition: 'left' },
        { name: 'EXAMES', propName: 'totalExams', widthPercent: 15, textPosition: 'left' },
        { name: 'VALOR TOTAL', propName: 'totalValue', widthPercent: 15, textPosition: 'left', valueType: 'R$' }
      ],
      isLoadingList: false,
      currentPage: 1,
      totalPages: 1,
      totalBilling: 0
    }
  },
  computed: {
    mesAno() {
      const { month, year } = this.$route.params

      return Moment(`${year}-${month}`, 'YYYY-MMM', 'pt', true).format('MMMM YYYY')
    },
    defaultStartDate() {
      return Moment(this.searchPeriod.startDate, 'YYYY-MM-DD').format('DD/MM/YYYY')
    },
    defaultEndDate() {
      return Moment(this.searchPeriod.endDate, 'YYYY-MM-DD').format('DD/MM/YYYY')
    }
  },
  mounted() {
    this.getResultsByFilter()
  },
  methods: {
    handleClickRow({ numberOs }) {
      this.$router.push(`/traceability/search?q=${numberOs}&typeOfSearch=OA`)
    },
    handleFilter() {
      this.currentPage = 1
      this.getResultsByFilter()
    },
    getResultsByFilter() {
      const { EXAM, OS_ALVARO, PATIENT, byResultDate, transferDateFrom, transferDateTo } = this.filter

      this.isLoadingList = true
      const searchType = byResultDate ? 'RESULT_RANGE' : 'CREATION_INTERVAL'
      const searchValue = EXAM || OS_ALVARO || PATIENT

      billings
        .getInvoiceData(
          {
            dates: {
              type: searchType,
              startDate: transferDateFrom ? Moment(transferDateFrom, 'DD/MM/YYYY').format('YYYY-MM-DD') : null,
              endDate: transferDateTo ? Moment(transferDateTo, 'DD/MM/YYYY').format('YYYY-MM-DD') : null
            },
            search: {
              type: searchValue ? Object.keys(this.filter).find(key => this.filter[key] === searchValue) : null,
              searchValue: searchValue || null
            }
          },
          this.invoiceId,
          this.currentPage
        )
        .then(response => {
          const { totalPages } = response.data
          const { billing } = response.data.content[0]

          this.totalBilling = formatCurrency(billing.totalBilling)
          this.totalPages = totalPages

          this.invoiceExams = billing.os
          this.isLoadingList = false
        })
        .catch(error => {
          this.isLoadingList = false

          const { response } = error.response.data

          if (response) {
            this.invoiceExams = []
            this.totalPages = 0
            notify({
              message: JSON.parse(response).errorMessage
            })
          } else {
            notify({
              title: 'Erro',
              message: 'Ocorreu um erro ao buscar os dados. Tente novamente mais tarde.'
            })
          }
        })
    },
    handleBackButton() {
      this.$router.push({ name: 'Faturamento' })
    },
    orderByProp(data) {
      if (data) {
        const { column, sortType } = data
        const sortedList = [...this.invoiceExams].sort((a, b) => {
          const valueA = a[column]
          const valueB = b[column]

          const isNumericA = !isNaN(parseFloat(valueA)) && isFinite(valueA)
          const isNumericB = !isNaN(parseFloat(valueB)) && isFinite(valueB)

          if (isNumericA && isNumericB) return sortType === 'asc' ? valueA - valueB : valueB - valueA
          else if (isNumericA) return sortType === 'asc' ? -1 : 1
          else if (isNumericB) return sortType === 'asc' ? 1 : -1
          else return sortType === 'asc' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA)
        })

        this.invoiceExams = sortedList
      }
    },
    handleChangePage(page) {
      this.currentPage = page
      this.getResultsByFilter()
    },
    handleSearchValueUpdate(value) {
      if (!value.date.start) {
        this.filter.transferDateFrom = null
        this.filter.transferDateTo = null
        return
      }

      if (value.type === 'date' || value.type === 'dateRange') {
        this.filter.byResultDate = value.type === 'dateRange'
        this.filter['transferDateFrom'] = this.defaultStartDate
        this.filter['transferDateTo'] = this.today

        if (this.isRangeValid(value.date)) {
          this.filter['transferDateFrom'] =
              value.date && value.date.start !== '' ? Moment(value.date.start).format('DD/MM/YYYY') : ''
          this.filter['transferDateTo'] =
              value.date && value.date.end !== '' ? Moment(value.date.end).format('DD/MM/YYYY') : ''
        }
      } else {
        this.filter.PATIENT = ''
        this.filter.OS_ALVARO = ''
        this.filter.EXAM = ''
        this.filter[value.type] = value.query
      }
    },
    isRangeValid(date) {
      const startDate = Moment(date.start)
      const endDate = Moment(date.end)
      const diffInDays = endDate.diff(startDate, 'days')

      if (diffInDays > 30) {
        return false
      }

      return true
    }
  }
}
</script>

<style lang="scss">
  @import '../../../static/stylesheets/variables';

  .invoice-details-view {
    min-height: 100vh;
    padding-top: $mainHeaderHeight;
    padding-bottom: 30px;
    margin-top: 6rem;
    font-family: 'Exo 2' !important;

    .data-row:hover {
      background-color: #fcf2f8;
      cursor: pointer;

      div {
        background-color: #fcf2f8;
      }
    }

    .empty-list {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 4rem;
    }

    &__search {
      display: flex;
      gap: 15px;
      align-items: center;

      .search {
        margin-top: 0;
        flex: 1;
      }

      .btn-search {
        height: 50px;
        width: 128px;

        .md-icon {
          margin-right: 6px;
        }
      }
    }

    .icon-arrow {
      cursor: pointer;
    }

    .wrapper {
      display: flex;
      width: 100%;
      justify-content: space-between;
      flex-wrap: wrap;
    }

    .total {
      margin-right: 2rem;
      font-size: 22px;
      color: #6d6d6d;

      span {
        color: #7f1a54;
        font-weight: 700;
      }
    }

    .filter {
      background-color: #fff;
      margin: 40px 0 24px 0;
      height: 176px;
      border-radius: 8px;
      padding: 2rem;

      h2 {
        color: #7f1a54;
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 24px;
      }
    }

    &__header {
      display: flex;
      align-items: center;
      color: #6d6d6d;
      gap: 15px;
      align-items: center;
      margin-bottom: 24px;

      h1 {
        font-size: 22px;
      }
    }
  }
</style>
